import { GET_AGENTS, GET_DEPARTAMENT } from './mutation-types'
import relatoriosOperadorHttpService from '../_services/relatoriosOperadorHttpService'

export default {
  listarDepartamento: async({ commit }) =>{
    try{
      const reponse = await relatoriosOperadorHttpService.getDepartment()
      commit(GET_DEPARTAMENT, reponse.data)
    }catch(e){
      console.log(e)
    }
  },

  buscarOperadores: async ({ commit }) => {
    try {
      const response = await relatoriosOperadorHttpService.getAgents()
      commit(GET_AGENTS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
